<template>
  <div>
    <div class="prompt mb-2">
      <div class="prompt-tip__title ml-3">
        {{ $l('dialog_label_operating') || '操作说明：' }}
      </div>
      <div class="prompt-tip__desc ml-3">
        {{
          $l('dialog_label_ex1') ||
            '1、批量预生成样品款号条码标签，仅针对已有实物样品无系统数据，需要补录样品资料的情况下使用'
        }}
      </div>
      <div class="prompt-tip__desc mt-1 ml-3">
        {{
          $l('dialog_label_ex2') ||
            '2、每次批量生成的样品款号条码数量，不能超过100，且预生成标签未使用完毕的情况下，不得再次生成'
        }}
      </div>
    </div>
    <el-row :gutter="10" class="mb-3">
      <el-col :span="24" style="text-align: center;">
        <span class="title_class">
          {{
            $l('dialog_label_ple_input') || '请输入本次需要生成的样品条码数量'
          }}
        </span>
        <div>
          <el-input-number
            :controls="false"
            size="small"
            style="width: 291px;height:82px"
            :min="0"
            :step="1"
            :precision="0"
            v-model="number"
            v-el-inputnumber-default0
          ></el-input-number>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: {},
  props: {},
  data() {
    return {
      formData: {},
      number: 0,
      loading: false,
      formulatDescriptionDialogVisible: false,
      rules: {
        topOneDailyQty: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      },
    }
  },

  mounted() {},
  methods: {
    close(flag) {
      this.$emit('close', { flag })
    },
    async save() {
      if (!this.number || this.number < 1) {
        this.$message.error(
          this.$l('dialog_label_ex3') ||
            '每次批量生成的样品款号条码数量，不能小于1'
        )
        return
      }
      if (this.number > 100) {
        this.$message.error(
          this.$l('dialog_label_ex4') ||
            '每次批量生成的样品款号条码数量，不能大于100'
        )
        return
      }

      this.$confirm(
        this.$l('tips_generate') || '是否批量预生成样品款号条码？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        if (this.loadingOpen()) return
        this.$api
          .prebuiltSampleBarcodeGenerationApi({
            number: this.number,
          })
          .then((res) => {
            if (!res) return
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })
            this.loadingClose()
            this.close(true)
          })
          .catch(() => this.loadingClose())
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.prompt {
  height: 100px;
  width: 710px;
  background-color: #fff6f7;
  border-radius: 5px 0px 0px 5px;
  border-left: 5px solid #f56c6c;
  .prompt-tip__title {
    font-size: 14px;
    font-weight: 600;
    color: #101010;
    padding: 9px 0;
  }
  .prompt-tip__desc {
    font-size: 14px;
    color: #8e8e8e;
  }
}
.title_class {
  color: #101010;
  font-size: 18px;
}

::v-deep .el-input__inner {
  margin-top: 14px;
  height: 82px;
  line-height: 82px;
  text-align: center;
  font-size: 40px;
  border: #bbbbbb 1px solid;
  color: #101010;
}
</style>
